import { useState } from "react";
import { Breadcrumbs } from "../breadcrumbs";
import { CreateGroupForm } from "../forms/create-group-form";
import { GroupsTable } from "../tables/groups-table";
import { Button } from "../ui/button";
import {
	Sheet,
	SheetContent,
	SheetHeader,
	SheetTitle,
	SheetTrigger,
} from "../ui/sheet";

export function GroupsPage() {
	const [open, setOpen] = useState(false);

	return (
		<div className="space-y-2">
			<Breadcrumbs />
			<Sheet open={open} onOpenChange={setOpen}>
				<div className="flex flex-col">
					<div className="flex justify-between">
						<h2>Groups</h2>
						<SheetTrigger render={<Button />}>Create Group</SheetTrigger>
						<SheetContent>
							<SheetHeader>
								<SheetTitle>Create A New Group</SheetTitle>
							</SheetHeader>
							<div className="px-4">
								<CreateGroupForm onComplete={() => setOpen(false)} />
							</div>
						</SheetContent>
					</div>
					<GroupsTable />
				</div>
			</Sheet>
		</div>
	);
}
